import { Card, Heading, Span } from "@icg360/design-system";

import { MobilePaymentSection } from "../../old/components/MobilePaymentSection/MobilePaymentSection";
import { PaymentSection } from "../../old/components/Section/Section";
import { ProposalData } from "../../types";
import styles from "./PaymentPlans.module.css";

interface PaymentPlansProps {
  payment: ProposalData["payment"];
  paymentSections: ProposalData["payment"]["sections"];
}

export const PaymentPlans = ({
  payment,
  paymentSections
}: PaymentPlansProps) => {
  return (
    <div className={styles.sectionContainer}>
      <Heading className={styles.sectionHeadingDS} size="lg">
        Payment plans
      </Heading>
      <Card title={"Plan options"}>
        <Span>{payment.text1}</Span>
        <div className={styles.desktopPaymentSections}>
          {paymentSections.map((sectionData, index) => (
            <PaymentSection
              key={sectionData.label ?? `section-${index}`}
              sectionData={sectionData}
            />
          ))}
        </div>
        <MobilePaymentSection paymentSections={paymentSections} />
        <Span className={styles.noteTextDS}>{payment.text2}</Span>
        <Heading className={styles.contactMeHeadingDS} size="md">
          Have questions or ready to purchase? Contact me!
        </Heading>
      </Card>
    </div>
  );
};
